import React from 'react';

interface LineIconProps {
  className?: string;
  size?: number;
}

export const LineIcon: React.FC<LineIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Main line with slight curve */}
      <path
        d="M5 19L19 5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Start point */}
      <circle
        cx="5"
        cy="19"
        r="1.5"
        fill="currentColor"
        opacity="0.8"
      />
      {/* End point */}
      <circle
        cx="19"
        cy="5"
        r="1.5"
        fill="currentColor"
        opacity="0.8"
      />
      {/* Subtle line shadow */}
      <path
        d="M5 19L19 5"
        stroke="currentColor"
        strokeWidth="0.5"
        opacity="0.3"
        strokeDasharray="1 1"
      />
    </svg>
  );
};

export default LineIcon;
